import { render, staticRenderFns } from "./score-board.vue?vue&type=template&id=e130af2a&scoped=true"
import script from "./score-board.vue?vue&type=script&lang=js"
export * from "./score-board.vue?vue&type=script&lang=js"
import style0 from "./score-board.vue?vue&type=style&index=0&id=e130af2a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e130af2a",
  null
  
)

export default component.exports